<template>
    <div id="support-page">
        <!-- JUMBOTRON -->
        <div class="faq-jumbotron">
            <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base text-center">
                <h1 class="mb-2 text-white font-bold">Υποστήριξη πελατών</h1>
                <p class="text-white">Μη διστάσετε να επικοινωνήσετε μαζί μας σε κάθε περίπτωση που αντιμετωπίζετε πρόβλημα με την εφαρμογή.</p>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-2/5 lg:w-2/4 rounded-lg">
                <vx-card>
                    <h4 class="text-primary mb-5">Intelliprice</h4>
                    <p>Λάδωνος 7,<br>15 235, Βριλήσσια, Αττική</p><br>
                    <p><strong>T:</strong> 210 61 96 810</p>
                    <p><strong>E:</strong> info@intelliprice.io</p>

                    <br><br>

                    <h4 class="mb-5 text-primary">Νομικά</h4>
                    <small><strong>Intelliprice Version:</strong> 2.0.1</small><br>
                    <small><strong>Άδεια χρήσης:</strong> 1E0AA210-08C5-12E3-8FFD-0800200C9A66</small>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-3/5 lg:w-2/4 mt-12 md:mt-0">
            <vx-card card-background="#787878" class="p-5">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span class="text-white">Ονοματεπώνυμο</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border v-model="fullname" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span class="text-white">Email</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border v-model="email" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span class="text-white">Τηλέφωνο</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border v-model="phone" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span class="text-white">Μήνυμα</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-textarea class="w-full" v-model="message" />
                    </div>
                </div>

                <vs-alert color="dark" class="mt-5" style="color:#fff" v-if="responseMessage">{{responseMessage}}</vs-alert>
                <div class="vx-row" v-if="!completed">
                    <div class="vx-col sm:w-2/3 w-full ml-auto">
                    <vs-button :color="colorx" type="flat" class="mb-0 float-right" @click="sendMail()">Αποστολή</vs-button>
                    </div>
                </div>
            </vx-card>


            </div>
        </div>
    </div>
</template>

<script>

import axios from "@/axios";

export default{
  data () {
    return {
        colorx:'#fff',
        fullname: '',
        email: '',
        phone:'',
        message:'',
        responseMessage:'',
        completed:false
    }
  },

  computed: {

  },
  methods: {
    sendMail() {
        let vm = this;
        vm.$vs.loading();
        axios.defaults.baseURL = localStorage.getItem('apiEndpoint');
        let token = localStorage.getItem('accessToken');
        axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
        axios.post("contact", { 'fullname': vm.fullname, 'email': vm.email, 'phone': vm.phone, 'message': vm.message })
            .then((response) => {
                if(response.data.error) {
                    vm.responseMessage = response.data.message;
                } else {
                    vm.responseMessage = response.data.message;
                    vm.completed = true;
                }
                vm.$vs.loading.close();
            })
            .catch((error) => {
                vm.$vs.loading.close();
            })
    }
  },
    mounted()  {
        let _token = localStorage.getItem('accessToken');
        var base64Payload = _token.split('.')[1];
        var payload = Buffer.from(base64Payload, 'base64');
        let _user = JSON.parse(payload);
        this.fullname = _user.name + " " + _user.surname;
        this.email = _user.email;
    },
  components: {

  }
}
</script>

<style lang="scss">
#support-page {
    .faq-jumbotron-content {
        background-image: url('../../assets/images/pages/faq.jpg');
        background-size: cover;
    }

    .faq-bg, textarea {
        background-color: #fff;
    }
}
</style>
